import { ItemInstance } from '@headless-tree/core';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';

import * as Styled from './priority-header.style';

export type PriorityHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
};

export const PriorityHeader: React.FC<PriorityHeaderProps> = ({ item }) => {
  const { t } = useTranslation();
  const priority = item.getItemData()?.sourceId;

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  return (
    <Styled.Container>
      <Typography variant="h6" component="span">
        {t(`general.sections.priority.${priority}.title`)}
      </Typography>

      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.Container>
  );
};
